import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { NonWorkingDay } from "@app/models/rest/roster/non-working-day";
import { NonWorkingDayRestService } from "@app/services/hal/roster/non-working-day-rest-service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class NonWorkingDayStore extends RealTimeDataStore<NonWorkingDay> {
  constructor() {
    const nonWorkingDayRestService = inject(NonWorkingDayRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(nonWorkingDayRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("NonWorkingDay");
  }
}
